import styled from 'styled-components';
import { IonModal } from '@ionic/react';

export const IonModalWrapper = styled(IonModal)`
  .qr-code {
    display: flex;
    justify-content: center;

    ::part(image) {
      width: 50%;
    }
  }

  .input-group {
    border-radius: 15px;
    border: 1px solid var(--ion-color-dark);
    padding: 0px;

    ion-icon {
      color: var(--ion-text-color);
    }
  }

  ion-item {
    padding-left: 15px;
    --background: transparent;
    --border-color: transparent;
    --color: var(--ion-text-color);
    --padding-start: 0px;
    .label {
      font-size: 0.9rem;
    }
  }

  .otp-key {
    text-align: center;
    font-size: 20px;
    letter-spacing: 10px;
    border: 1px solid rgb(0, 0, 0);
    border-radius: 10px;
    padding: 10px;
    margin: 30px 0;
  }

  .instruction-label {
    font-size: 1rem;
    display: flex;
    justify-content: center;
  }
`;
